"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const link_helpers_1 = require("./link_helpers");

function makeProviderName(link) {
  if ((0, link_helpers_1.isPadlet)(link)) {
    return (0, link_helpers_1.firstAuthorName)(link) || 'Padlet';
  }

  return link.provider_name;
}

exports.default = makeProviderName;